import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  if (!sessionStorage.getItem("auth_token")) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default PrivateRoute;
